<template>
  <div class="invoice-container">
    <nav class="add-navigation">
      <!-- <search-input class="search-input"
                    type="text"
                    v-model="SearchUser"
      placeholder="Search for user" />-->
      <div class="primary-button">
        <primary-button
          @click.native="$router.push({name: 'reseller-billing-add-payment'})"
        >Add Payment</primary-button>
      </div>
    </nav>
    <div class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
      <table class="Invoice_table">
        <thead>
          <tr class="Invoice_table_header table-header">
            <th>Payment #</th>
            <th>Paid On</th>
            <th>Gateway</th>
            <th>Method</th>
            <th>Total</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr class="line" v-for="(payment, k) in payments" :key="k">
            <th>{{payment.invoiceNumber}}</th>
            <th>{{payment.paidOn}}</th>
            <th class="creadted_by">
              <!-- <img class="popup_image" src="@/assets/person.jpg" alt /> -->
              {{payment.createdBy}}
            </th>
            <!--  -->
            <th class="method">{{payment.method}}</th>
            <th class="Invoice_price">${{payment.amount}}</th>
            <th class="icon">
              <div class="Invoice_table_popup">
                <b-dropdown variant="link" size="lg" no-caret>
                  <template slot="button-content">
                    <span class="popup_cta">...</span>
                  </template>
                  <b-dropdown-item href="#">Download Excel Summary</b-dropdown-item>
                  <b-dropdown-item href="#">Download PDF</b-dropdown-item>
                </b-dropdown>
              </div>
            </th>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="per-page">
      <span class="filter_by custom-row">Show Per Page:</span>
      <div class="primary-input-container choose-type perPage">
        <primary-select
          type="text"
          @input="changePerPage"
          v-model="per_page" :is-cross="false"
          class="choose-type perPage"
          placeholder="Select"
        >
          <option :value="item" v-for="(item,key) in pages" :key="key">{{item}}</option>
        </primary-select>
      </div>
    </div>
    <div class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :per-page="per_page"
        :total="TotalPages"
        :qnt="payments.length"
      />
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    DownloadAttachmentDropDown: () =>
      import("@/components/DropDowns/Billing/DownloadAttachmentDropDown.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
  },
  data: () => ({
    showDropDown: false,
    payments: [],
    per_page: 10,
    pages: [10, 50, 100],
    Total: null,
    Searched: "",
    Page: 0,
    TotalPages: null,
  }),
  computed: {},
  created() {
    this.GetList(this.Searched, this.Page);
  },
  methods: {
    changePerPage(e) {
      this.Page = 0;
      this.GetList();
    },
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    GetList(search, page) {
      this.$store
        .dispatch("GetPaymentList", {
          search: search,
          page: this.Page,
          per_page: this.per_page,
        })
        .then((res) => {
          console.log("res--->", res);
          this.payments = res.items.map(this.transformPayments);
          this.TotalPages = res.total / res.per_page;
        });
    },
    transformPayments(i, k) {
      return {
        paymentId: i.payment_uuid,
        invoiceNumber: i.invoice_number,
        method: i.method,
        paidOn: format(i.paid_on, "D MMM YYYY"),
        createdBy: i.created_by,
        companyName: i.company_name,
        amount: i.amount,
      };
    },
    outside() {
      this.showDropDown = false;
    },
    next() {
      let count = this.Total - this.per_page * this.Page;
      if (count > this.per_page) {
        this.Page++;
        this.GetList(this.Searched, this.Page);
      }
    },
    prev() {
      if (this.Page !== 0) {
        this.Page--;
        console.log("page", this.Page);
        this.GetList(this.Searched, this.Page);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-container {
  .per-page {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .perPage {
    width: 120px;
    margin-right: 15px;
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: fit-content;
    float: right;
    margin-top: 20px;
    margin-bottom: 20px;
    .search-input {
      height: 40px;
      width: 345px;
      background-color: #ffffff;
    }
    .primary-button {
      height: 40px;
      width: 140px;
    }
  }
  .buttons-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    .secondary-button {
      height: 40px;
      width: 90px;
      margin-right: 15px;
    }
  }
}
table.Invoice_table {
  width: 100%;
  margin-top: 20px;

  th {
    text-align: center;
  }
  .table-header th {
    padding: 10px 15px;
    border: 1px solid #dddedf;
    background: #51a3f3;
    color: #fff;
  }
}
table thead tr {
  height: 37px;
  background: #f8f9fe;
  text-align: left;
}
table,
tr {
  width: 100%;
  height: 50px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 15px 0;
}
table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  height: 30px;
  text-align: right;
  position: relative;
  float: right;
  .popup_cta {
    cursor: pointer;
    color: #55616e;
  }
}
.Invoice_table_header th {
  color: #212b36;
  font-family: "Helvetica Neue";
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  padding: 11px 0 10px 0;
}
.popup_content {
  display: none;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 15px 10px;
  text-align: left;
}
table th:first-child {
  padding-left: 15px;
}
tbody th.creadted_by {
  padding: 10px 0 10px 0;
}
tbody th.method {
  width: 110px;
  color: #55616e;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 25px;
  height: 25px;
  padding: 13px 0 12px 0;
}
th.icon {
  float: right;
  padding: 7px 5px 7px 0;
}
.Invoice_price {
  font-family: "Helvetica Neue";
  padding: 13px 0 12px 0;
  color: #000000;
  font-weight: bold;
}
.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
}
th.user_active:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 25px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding-left: 32px;
}

.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}

@media screen and (max-width: 1500px) {
  table.Invoice_table {
    width: 1400px;
  }
}
</style>

